import { cn } from "../ui/cn";

export function ActionRow({ actions }: { actions: string[] }) {
  return (
    <div className="flex w-full gap-1.5 mt-2 mb-1 [animation:ss-bubble-in_400ms_cubic-bezier(0.16,1,0.3,1)]">
      {actions.map((label, i) => (
        <div
          key={i}
          className={cn(
            "flex-1 text-center rounded-lg px-3 py-[9px] text-[13.5px] font-medium",
            i === 0
              ? "bg-accent text-bg"
              : "bg-tg-bubble-in/90 text-white border border-white/[0.06]",
          )}
        >
          {label}
        </div>
      ))}
    </div>
  );
}
